const DEFAULT_TOKEN_KEY = 'token';
const DEFAULT_DRIVER_IDS_KEY = 'driver_ids';

export const saveToken = (token: string): void => {
    localStorage.setItem(DEFAULT_TOKEN_KEY, token);
};

export const removeToken = (): void => {
    localStorage.removeItem(DEFAULT_TOKEN_KEY);
};

export const getToken = (): string | null => {
    return localStorage.getItem(DEFAULT_TOKEN_KEY);
};

export const getDriver =(): string | null => {
    return localStorage.getItem('driver');
};

export const saveDriver = (driver: string): void => {
    localStorage.setItem('driver', driver);
};
export const getDriverIDs = (): number[] => {
    const stored = localStorage.getItem(DEFAULT_DRIVER_IDS_KEY);
    try {
        return stored ? JSON.parse(stored) : [];
    } catch {
        return [];
    }
};

export const saveDriverIDs = (driverIds: number[]): void => {
    localStorage.setItem(DEFAULT_DRIVER_IDS_KEY, JSON.stringify(driverIds));
};